module.exports = __webpack_public_path__ + "img/photo2.a03a6e92.png";